import {
  SET_CONTRIBUTION_CHOICE_ADMIN,
  SET_DATA_FIELD,
  SET_IMAGE_GROUP,
  SET_IMAGE_HEADER,
  SET_OPEN_MENU,
  SET_USER_POINT,
} from './constants';

export type STATE = {
  isOpenMenu: boolean;
  imageGroup: string;
  imageHeader: number;
  textWhatIs: string[];
  dataByMode: string[];
  userPoint: string[];
  contributionChoiceAdmin: {
    one_stop?: boolean;
    residentRecord?: string;
    cancellationPolicy?: string;
    oneStopDocument?: string;
  };
};

const initState: STATE = {
  isOpenMenu: false,
  imageGroup: '',
  imageHeader: 0,
  textWhatIs: [],
  dataByMode: [],
  userPoint: [],
  contributionChoiceAdmin: {},
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case SET_OPEN_MENU:
      return {
        ...state,
        isOpenMenu: action.payload,
      };
    case SET_IMAGE_GROUP:
      return {
        ...state,
        imageGroup: action.payload,
      };
    case SET_IMAGE_HEADER:
      return {
        ...state,
        imageHeader: state.imageHeader + 1,
      };
    case SET_DATA_FIELD:
      return {
        ...state,
        dataByMode: action.payload,
      };
    case SET_USER_POINT:
      return {
        ...state,
        userPoint: action.payload,
      };
    case SET_CONTRIBUTION_CHOICE_ADMIN:
      return {
        ...state,
        contributionChoiceAdmin: action.payload,
      };
  }
}

export { initState };
export default reducer;
